const Iris = {
  xsdString: 'http://www.w3.org/2001/XMLSchema#string',
  rdfLangString: 'http://www.w3.org/1999/02/22-rdf-syntax-ns#langString',
  owlNamedIndividual: 'http://www.w3.org/2002/07/owl#NamedIndividual',
  recHasPopularName: 'https://w3id.org/rec/core/hasPopularName',
  recHasLittera: 'https://w3id.org/rec/core/hasLittera',
  casoHasPropertyRegisterDesignation:
    'https://rec.castellum.se/ontology/hasPropertyRegisterDesignation',
  woboHasPropertyRegisterDesignation:
    'https://rec.webofbuildings.com/ontology/hasPropertyRegisterDesignation',
  recName: 'https://w3id.org/rec#name',
  recAddressLine: 'https://w3id.org/rec#addressLine1',
  recPostalCode: 'https://w3id.org/rec#postalCode',
  recCity: 'https://w3id.org/rec#city',
  // WOBO classes shall be in wob-client.
  woboApartmentNumber: 'https://webofbuildings.com/ontology/apartmentNumber',
  recPostalAddress: 'https://w3id.org/rec#PostalAddress',
  recPoint: 'https://w3id.org/rec#Point',
  recCoordinates: 'https://w3id.org/rec#coordinates',
  recValue: 'https://w3id.org/rec#value',
  recTimestamp: 'https://w3id.org/rec#timestamp',
  recEnd: 'https://w3id.org/rec#end',
  recStart: 'https://w3id.org/rec#start',
}

const Jsonld = {
  id: '@id',
  type: '@type',
  context: '@context',
  value: '@value',
  language: '@language',
}

class Value {
  constructor(value) {
    this._value = value
  }
  get value() {
    return this._value
  }
  set value(value) {
    this._value = value
  }
  equals(value) {
    // TODO check both Value instance as well as value literal,
    // eg (value.value || value) == this._value
    return value == this._value
  }
}

// TODO allow for no namespaces, shorten may be implemented, prefix will have to be equal to value.
class Iri extends Value {
  constructor(value = '', namespaces = null) {
    super(value)
    this._prefixed = namespaces?.prefix(value) || value
    this._short = namespaces?.shorten(value) || value
  }
  get prefixed() {
    return this._prefixed
  }
  get short() {
    return this._short
  }
  get isDefined() {
    return !!this._value
  }
}

class Literal extends Value {
  constructor(value = '', datatype = Iris.xsdString) {
    super(value)
    this._datatype = datatype
  }
  get datatype() {
    return this._datatype
  }
  equals(value) {
    return (
      Value.prototype.equals.call(this, value) &&
      value?.datatype == this._datatype
    )
  }
}

class LanguageString extends Literal {
  constructor(value, language) {
    super(value, Iris.rdfLangString)
    this._language = language
  }
  get language() {
    return this._language
  }
  equals(value) {
    return (
      Value.prototype.equals.call(this, value) &&
      value?.datatype == Iris.rdfLangString &&
      value?.language == this._language
    )
  }
}

// A Property comprises a name IRI and an array of Value objects.
class Property {
  constructor(name, ...values) {
    this._name = name instanceof Iri ? name : new Iri(name)
    this._values = values
  }
  get name() {
    return this._name
  }
  get values() {
    return this._values
  }
  addValue(v) {
    const value = v instanceof Value ? v : new Value(v)
    if (!this._values.find((v) => v.equals(value))) this._values.push(value)
    return this
  }
  removeValue(v) {
    const value = v instanceof Value ? v : new Value(v)
    this._values = this._values.filter((v) => !v.equals(value))
    return this
  }
  updateValue(oldV, newV) {
    return this.removeValue(oldV).addValue(newV)
  }
}

// Each value in values may be a string or an object { @value, [ @language ] }.
// TODO with expanded form its always an object.
class DataProperty extends Property {
  constructor(name = '', values = []) {
    // TODO expects values to be formated as Value descendents...
    super(name, ...values)
    // super(
    //   name,
    //   ...values.map((v) =>
    //     typeof v == 'string'
    //       ? new Literal(v)
    //       : v[Jsonld.language]
    //       ? new LanguageString(v[Jsonld.value], v[Jsonld.language])
    //       : new Literal(v[Jsonld.value])
    //   )
    // )
  }
}

// Each value in values is an IRI.
// TODO introduce check for type in values.
class ObjectProperty extends Property {
  constructor(name, values) {
    super(
      name,
      ...values.map((v) => (v instanceof Iri ? v : new Iri(v[Jsonld.value])))
    )
  }
}

export {
  Iris,
  Jsonld,
  Value,
  Iri,
  Literal,
  LanguageString,
  Property,
  DataProperty,
  ObjectProperty,
}
